//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Loading } from 'element-ui';

export default {
    props: {
        labelWidth: {
            type: String,
            default: '120px'
        },
        value: {
            type: Object,
            default: () => ({})
        },
        submitUrl: {
            type: String,
            default: ''
        },
        detailUrl: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'small'
        },
        labelPosition: {
            type: String,
            default: 'right'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        beforeSend: {
            type: [Function, Boolean],
            default: false
        },
        afterSend: {
            type: [Function, Boolean],
            default: false
        },
        afterDetail: {
            type: [Function, Boolean],
            default: false
        },
        detailExtra: {
            type: Object,
            default: () => ({})
        },
        sendStr: {
            type: Boolean,
            default: false
        },
        file: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        },
        table: {
            type: Boolean,
            default: false
        },
        showBtn: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            submitLoadingController: false,
            submitLock: false,

            elLoading: null
        }
    },
    computed: {
        form: {
            get: function () {
                return this.value
            },
            set: function (n) {
                this.$emit('input', n);
            }
        },
        btn_styl: function () {
            return {
                'display': 'inline-block'
            }
        }
    },
    methods: {
        onSubmit: function (e, callback) {
            var ajaxRes;

            new window.Chain().link(function (obj, next) {
                if (obj.submitLock) {
                    window.ShowMsg.call(obj, '提交过快，请稍后重试');
                    return;
                }

                obj.lockSubmit();

                next();
            }).link(function (obj, next) {
                if (obj.submitLoadingController) {
                    return;
                }

                obj.submitLoadingController = true;
                
                next();
            }).link(function (obj, next) {
                obj.$nextTick(function () {
                    next()
                });
            }).link(function (obj, next) {
                if(obj.beforeSend) {
                    obj.beforeSend(function() {
                        obj.$nextTick(function () {
                            next();
                        })
                    }, function() {
                        obj.submitEnd();
                    });
                } else {
                    next();
                }
            }).link(function (obj, next) {
                obj.$refs['form'].validate(function (valid) {
                    if (valid) {

                        Object.keys(obj.form).forEach(function (key) {
                            obj.form[key] = typeof (obj.form[key]) === 'string' ?
                            obj.form[key].replace(/^\s+|\s+$/g, "") :
                            obj.form[key];
                        });

                        if (obj.submitUrl) {
                            obj.$ajax({
                                type: 'post',
                                url: obj.submitUrl,
                                data: obj.form,
                                callback: function (data, res) {
                                    ajaxRes = res;
                                    obj.$emit('submit');
                                    window.ShowMsg.call(obj, res.msg || '保存成功', 'success');

                                    obj.close();

                                    !!callback && callback();
                                },
                                fztype: obj.sendStr,
                                complete: function () {
                                    next();
                                }
                            });
                        } else {
                            obj.$emit('submit');
                            next();
                        }
                    } else {
                        obj.submitEnd();
                        return false;
                    }
                });
            }).link(function (obj, next) {
                !!obj.afterSend && obj.afterSend(ajaxRes);
                obj.$nextTick(function () {
                    next();
                })
            }).link(function (obj, next) {
                obj.submitEnd();
                obj.$nextTick(function () {
                    next();
                });
            }).run(this);
        },
        onCancle: function () {
            this.$emit('cancle');
        },
        close: function () {
            try {
                this.onCancle();

                this.submitEnd();
            } catch (e) {}
        },
        submitEnd: function () {
            this.submitLoadingController = false;
        },
        lockSubmit() {
            this.submitLock = true;

            setTimeout(function () {
                this.submitLock = false;
            }.bind(this), 1000);
        },
        queryDetail: function () {
            if (this.detailUrl) {
                var that = this;

                this.elLoading = Loading.service({
                    target: this.$el,
                    lock: true,
                    text: '数据加载中...'
                });

                if (this.file) {
                    this.$get(this.detailUrl, this.detailExtra, function (data) {
                        !!this.afterDetail && this.afterDetail(data);
                        this.form = data;

                        this.elLoading.close();
                    })
                } else {
                    var extra = true;

                    if(this.detailExtra) {
                        var queryKeys = Object.keys(this.detailExtra);

                        if(!queryKeys.length) {
                            extra = false;
                        } else {
                            queryKeys.forEach(function (item) {
                                if (!that.detailExtra[item]) extra = false;
                            });
                        }
                    } else {
                        extra = false;
                    }

                    if (extra) {
                        this.$get(this.detailUrl, this.detailExtra, function (data) {
                            !!this.afterDetail && this.afterDetail(data);
                            this.form = data;

                            this.elLoading.close();
                        })
                    } else {
                        !!this.afterDetail && this.afterDetail();

                        this.elLoading.close();
                    }
                }
            }
        },
        reset: function () {
            this.$refs['form'].resetFields();
        }
    },
    mounted: function () {
        this.queryDetail();
    }
}
